import { LoggedInUser } from '../../../common/types';
import { Language } from '@yleisradio/areena-types';
import { App } from '@yleisradio/areena-types/domain/app';
import { fetchAppData } from '../fetchers';
import { useAuthContext } from '../../../client/contexts/AuthContext/AuthContext';
import { useAppFeaturesContext } from '../../../client/contexts/AppFeaturesContext/AppFeaturesContext';
import useSWRImmutable from 'swr/immutable';

type AppRequestKey = [
  'app.json',
  currentUser: LoggedInUser,
  language: Language,
];

async function appFetcher([
  ,
  currentUser,
  language,
]: AppRequestKey): Promise<App> {
  return fetchAppData(currentUser, language);
}

export function useFetchAppData() {
  const { languageCode } = useAppFeaturesContext();
  const { user } = useAuthContext();

  const { data } = useSWRImmutable(
    user ? (['app.json', user, languageCode] satisfies AppRequestKey) : null,
    appFetcher
  );

  return data;
}
